import {
  collection,
  doc,
  setDoc,
  getDocs,
  deleteDoc,
} from 'firebase/firestore';
import { db } from '../config/firebase';

const GALLERY_CATEGORIES = [
  {
    id: 'sensory-play-area',
    label: 'Sensory Play Area',
    icon: '🧩',
    color: 'brand-yellow',
    order: 1,
    images: [],
  },
  {
    id: 'learning-materials',
    label: 'Learning Materials',
    icon: '📚',
    color: 'brand-blue',
    order: 2,
    images: [],
  },
  {
    id: 'classroom-activities',
    label: 'Classroom Activities',
    icon: '🎨',
    color: 'brand-pink',
    order: 3,
    images: [],
  },
  {
    id: 'garden-area',
    label: 'Garden Area',
    icon: '🌳',
    color: 'brand-green',
    order: 4,
    images: [],
  },
];

export const initializeGalleryCategories = async () => {
  try {
    console.log('Initializing gallery categories...');

    // Check if categories already exist
    const galleryCollection = collection(db, 'gallery');
    const snapshot = await getDocs(galleryCollection);

    if (snapshot.size > 0) {
      console.log('Gallery categories already exist. Skipping initialization.');
      return;
    }

    // Create each category
    for (const category of GALLERY_CATEGORIES) {
      const categoryRef = doc(db, 'gallery', category.id);
      await setDoc(categoryRef, category);
      console.log(`Created category: ${category.label}`);
    }

    console.log('✅ Gallery categories initialized successfully!');
  } catch (error) {
    console.error('Error initializing gallery categories:', error);
    throw error;
  }
};

// Function to remove obsolete categories
export const removeObsoleteCategories = async () => {
  try {
    console.log('Removing obsolete gallery categories...');

    const categoriesToRemove = ['reading-nook', 'creative-corner'];

    for (const categoryId of categoriesToRemove) {
      const categoryRef = doc(db, 'gallery', categoryId);
      await deleteDoc(categoryRef);
      console.log(`Removed category: ${categoryId}`);
    }

    console.log('✅ Obsolete categories removed successfully!');
  } catch (error) {
    console.error('Error removing obsolete categories:', error);
    throw error;
  }
};

// Run this function once to initialize the database
// You can call this from a component or run it manually
export default initializeGalleryCategories;
